import { render, staticRenderFns } from "./PropertyGroupSelectModal.vue?vue&type=template&id=6f444f1f&scoped=true"
import script from "./PropertyGroupSelectModal.vue?vue&type=script&lang=js"
export * from "./PropertyGroupSelectModal.vue?vue&type=script&lang=js"
import style0 from "./PropertyGroupSelectModal.vue?vue&type=style&index=0&id=6f444f1f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f444f1f",
  null
  
)

export default component.exports